<template lang="pug">
.mb-S
  label(v-if="label") {{ label }}
  briq-required-and-optional-markers(
    :isRequired="this.$attrs.required"
    :isDisabled="this.$attrs.disabled || this.$attrs.readonly"
    :hideOptionalMarker="hideOptionalMarker"
    :label="label"
    )
  briq-tooltip(:help="help")  
  .input-holder
    BriqDateTimePicker(
      name="AvailabilityStartDate"
      id="availabilityStartDate"
      v-model="availableFromInnerValue"
      placeholder="Available from"
      autocomplete="off"
      data-test-id="deal-availability-start-date"
      :showClearButton="showClearButton"
      )
    span(class="separator") until
    BriqDateTimePicker(
      name="AvailabilityEndDate"
      id="availabilityEndDate"
      v-model="availableToInnerValue"
      placeholder="Available until"
      autocomplete="off"
      data-test-id="deal-availability-end-date"
      :showClearButton="showClearButton"
      )
  .validation-message(v-if="availabilityDatesError" data-test-id="briq-availability-dates-input-error") {{ availabilityDatesError }}
</template>

<script>
import BriqDateTimePicker from '@/vue/components-global/BriqDateTimePicker.vue'

export default {
  name: 'AvailabilityDateRange',
  inject: ['validations'],
  props: {
    label: String,
    help: String,
    hideOptionalMarker: Boolean,
    deal: { type: Object, requred: true },
  },
  components: { BriqDateTimePicker },
  data() {
    return {
      showClearButton: true,
    }
  },
  computed: {
    availableFromInnerValue: {
      get() {
        return this.deal.AvailabilityStartDate
      },
      set(newVal) {
        this.deal.AvailabilityStartDate = newVal
      },
    },
    availableToInnerValue: {
      get() {
        return this.deal.AvailabilityEndDate
      },
      set(newVal) {
        this.deal.AvailabilityEndDate = newVal
      },
    },
    availabilityDatesError() {
      const showError =
        this.validations.$dirty &&
        this.validations.deal.AvailabilityStartDate.$invalid &&
        !this.validations.deal.AvailabilityStartDate.startDateIsBeforeOrEqualToEndDate

      return showError ? 'The Date from date should be before Date until date' : null
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/variables.styl'

label
  {typeBold}
  display inline-block
  max-width 100%
  margin-bottom 5px

.input-holder
  display flex
  align-items center
  width 60%
  height 40px

  .separator
    {typeBold}
    margin 0 space-XS
</style>
